import { useMutation, useQueryClient } from '@tanstack/react-query';
import { createConversation } from '../../services/backendService';
import { SupportedLanguage } from '../../lib/i18n';
import type { ConversationType } from '../../types/conversationItem.types';
// Define the interface locally to match what's used in backendService
interface CreateConversationParams {
  language?: SupportedLanguage;
  type?: ConversationType;
  selectedPersonaGroups?: string[];
}

/**
 * Hook for creating a new conversation using TanStack Query
 * @returns Mutation object for conversation creation
 */
export const useCreateConversation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: ['createConversation'],
    mutationFn: ({ language, type = 'USER', selectedPersonaGroups }: CreateConversationParams) =>
      createConversation({ language, type, selectedPersonaGroups }),
    onSuccess: (data) => {
      // When a new conversation is created, invalidate any existing conversation queries
      if (data?.id) {
        queryClient.invalidateQueries({
          queryKey: ['conversation', data.id],
        });

        // Optionally, you could also invalidate the conversations list if you have one
        // queryClient.invalidateQueries({ queryKey: ['conversations'] });
      }
    },
  });
};
